import { render, staticRenderFns } from "./AnswerEn.vue?vue&type=template&id=4df1f732&scoped=true&"
import script from "./AnswerEn.vue?vue&type=script&lang=js&"
export * from "./AnswerEn.vue?vue&type=script&lang=js&"
import style0 from "./AnswerEn.vue?vue&type=style&index=0&id=4df1f732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df1f732",
  null
  
)

export default component.exports